import moment from "moment";
export default
{
    find_in_m_data(md_data, t, val, add) {
        if (md_data.length > 0) {

            let obj = md_data.find((item) => parseInt(item[0]) === parseInt(t));
            if (obj) {
                let val = obj[1];
                let  addon = '';
                if (val === '30') addon = '-90';
                else if (val === '90') addon = '-180';
                else if (val === '180') addon = '-270';
                else if (val === '270') addon = '-330';
                else if (val === '330') addon = '-355';
                else if (val === '355') addon = '-364';
                let vv  = val + addon + ' denná';
                if (val === '30plus') vv = '&gt;30 denná';
                else if (val === '364') vv = '&le;364 denná';

                return vv;
            }
        }

        return val + add;

    },

    find_in_mm_data(mm_data, t, val, add) {
        if (mm_data.length > 0) {

            var res = mm_data.filter(item => parseInt(item[0]) === parseInt(t * 1000));
            if (res && res.length > 0) {
                return res[0][1] + '%';
            }
        } else {
            return val + add;
        }
    },

    getKvantilTrans(dt, val, kvantily) {
        let mesiac = moment(dt).month();
        let arr_trans = {'f10':{'txt':'sucho','color':'#FF5050'},
            'f40':{'txt':'mierne sucho','color':'#FFCC99'},
            'f60':{'txt':'normal','color':'#FFFFFF'},
            'f90':{'txt':'mierne nadpriemerná hladina','color':'#AFC2F7'},
            'f90p':{'txt':'nadpriemerná hladina','color':'#6699FF'}
        };
        if (kvantily[mesiac]) {
            let data = kvantily[mesiac];
            let k = null;
            if (val < data.f10) k = 'f10';
            else if (val < data.f40) k = 'f40';
            else if (val < data.f60) k = 'f60';
            else if (val < data.f90) k = 'f90';
            else if (val < data.f90p) k = 'f90p';
            else return '';

            let color = arr_trans[k].color;
            let txt = arr_trans[k].txt;

            return '<span style="border:1px solid #111; width:10px; height:10px; display:block; float:left; margin-right:5px; background-color:'+color+';"></span> ' + txt;

        } else {
            return '';
        }


    }

}
